
import { DailyLogNote_validate, DailyLogTitle_validate, StartDate_validate, ChallengeTitle_validate } from "../Challenge.js";
import { NonEmptyStringModule_create } from "../BaseTypes.js";
import { concat } from "../../fable_modules/fable-library-js.5.3.0/String.js";

/**
 * Validates challenge title — delegates to ChallengeTitle domain type
 */
export function validateTitle(title) {
    const matchValue = ChallengeTitle_validate(title);
    if (matchValue.tag === 1) {
        return matchValue.fields[0];
    }
    else {
        return undefined;
    }
}

/**
 * Validates challenge start date — delegates to StartDate domain type
 */
export function validateStartDate(today, date) {
    const matchValue = StartDate_validate(today, date);
    if (matchValue.tag === 1) {
        return matchValue.fields[0];
    }
    else {
        return undefined;
    }
}

/**
 * Validates daily log title — delegates to DailyLogTitle domain type
 */
export function validateDailyLogTitle(title) {
    const matchValue = DailyLogTitle_validate(title);
    if (matchValue.tag === 1) {
        return matchValue.fields[0];
    }
    else {
        return undefined;
    }
}

/**
 * Validates daily log note — delegates to DailyLogNote domain type
 */
export function validateDailyLogNote(note) {
    const matchValue = DailyLogNote_validate(note);
    if (matchValue.tag === 1) {
        return matchValue.fields[0];
    }
    else {
        return undefined;
    }
}

/**
 * Validates a required free-text field using NonEmptyString (trims before checking).
 * Returns Some fieldLabel + " is required" when blank, otherwise None.
 */
export function validateRequiredField(fieldLabel, value) {
    const matchValue = NonEmptyStringModule_create(value);
    if (matchValue.tag === 1) {
        return concat(fieldLabel, " is required");
    }
    else {
        return undefined;
    }
}

//# sourceMappingURL=FormUtils.js.map
